import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Form } from 'react-bootstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';

const VALIDATION_TYPE_OPTIONS = [
  { value: 'GREATER THAN', label: 'Greater Than (Numeric)' },
  { value: 'LESS THAN', label: 'Less Than (Numeric)' },
  { value: 'DATE GREATER THAN', label: 'Date Within Last N Days' },
  { value: 'DATE LESS THAN', label: 'Date Older Than N Days' },
  { value: 'EQUALS', label: 'Equals' },
  { value: 'NOT EQUALS', label: 'Not Equals' },
  { value: 'CONTAINS', label: 'Contains' },
  { value: 'NOT CONTAINS', label: 'Does Not Contain' },
  { value: 'REGEX MATCH', label: 'Regex Match' },
];

function DataSourceValidationConfigsViewRow({ attributeMap, config, isNewRow, onSave, onDelete }) {
  const [sourceAttribute, setSourceAttribute] = useState(config?.sourceAttribute || '');
  const [validationType, setValidationType] = useState(config?.validationType || '');
  const [validationValue, setValidationValue] = useState(config?.validationValue || '');
  const [recordFormat, setRecordFormat] = useState(config?.recordFormat || '');

  useEffect(() => {
    if (config) {
      setSourceAttribute(config.sourceAttribute || '');
      setValidationType(config.validationType || '');
      setValidationValue(config.validationValue || '');
      setRecordFormat(config.recordFormat || '');
    }
  }, [config]);

  const sourceAttributeOptions = Object.keys(attributeMap).map(attribute => ({
    value: attribute,
    label: attribute,
  }));

  const handleSave = () => {
    if (sourceAttribute && validationType && validationValue) {
      onSave({ sourceAttribute, validationType, validationValue, recordFormat });
      if (isNewRow) {
        // Clear the form for new row
        setSourceAttribute('');
        setValidationType('');
        setValidationValue('');
        setRecordFormat('');
      }
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <tr>
      <td>
        <Select
          options={sourceAttributeOptions}
          value={sourceAttributeOptions.find(option => option.value === sourceAttribute) || null}
          onChange={option => setSourceAttribute(option?.value || '')}
          isClearable
        />
      </td>
      <td>
        <Select
          options={VALIDATION_TYPE_OPTIONS}
          value={VALIDATION_TYPE_OPTIONS.find(option => option.value === validationType) || null}
          onChange={option => setValidationType(option?.value || '')}
          isClearable
        />
      </td>
      <td>
        <Form.Control
          type="text"
          value={validationValue}
          onChange={e => setValidationValue(e.target.value)}
        />
      </td>
      <td>
        <Form.Control
          type="text"
          value={recordFormat}
          onChange={e => setRecordFormat(e.target.value)}
          placeholder="e.g. YYYY-MM-DD"
        />
      </td>
      <td>
        {isNewRow && (
          <Button
            variant="primary"
            size="sm"
            onClick={handleSave}
            disabled={!sourceAttribute || !validationType || !validationValue}
          >
            Add
          </Button>
        )}
        {!isNewRow && (
          <Button className="ml-2" variant="danger" size="sm" onClick={handleDelete}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </Button>
        )}
      </td>
    </tr>
  );
}

DataSourceValidationConfigsViewRow.propTypes = {
  attributeMap: PropTypes.object.isRequired,
  config: PropTypes.shape({
    sourceAttribute: PropTypes.string,
    validationType: PropTypes.string,
    validationValue: PropTypes.string,
    recordFormat: PropTypes.string,
  }),
  isNewRow: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
};

DataSourceValidationConfigsViewRow.defaultProps = {
  config: null,
  isNewRow: false,
  onDelete: null,
};

export default DataSourceValidationConfigsViewRow;
